// extracted by mini-css-extract-plugin
export default {"partyStandings":"party-standings_partyStandings__QZIt7","total":"party-standings_total__Cfp45"};